import anime from 'animejs';

window.berenbergCart = {items:[]};
window.addBook = addBook;
window.booksInCart = 0;

let shopItemsNo = document.getElementById("link__shop-items");
let cardNotification = document.getElementsByClassName("nav__notifications");


// animations to show addBook modal
const showNotification = anime({
	easing: 'easeOutQuart',
	duration: 200,
	targets: cardNotification[0],
	autoplay: false,
	delay: 2000,

	opacity: [1,0],

	begin: function() {		
		cardNotification[0].style.display = "grid";

	},

	complete: function() {
		cardNotification[0].style.display = "none";
	},
});


// helper function to check expiration date
function isExpired() {
	// expiration time of shopping card
	var hours = 12; 
	var now = new Date().getTime();
	var expirationTime = localStorage.getItem('expirationTime');

	// check wether expiration time is set or not
	if (expirationTime == null) {
	  localStorage.setItem('expirationTime', now);
	  console.log("no expiration date set");
	  return true;
	} 
	else {
		// update expiration time
		localStorage.setItem('expirationTime', now);
		
		// return true if expiration time is more than "hours"
		if(now-expirationTime > hours*60*60*1000) {
			console.log("expiration date set, but exceeded");
			return true;
		}
		else {
			console.log("expiration date set, but not exceeded");
			return false;
		}
	}
}

// check if card is expired 
export function initCart() {
	if( isExpired() ) {
		console.log("Card is empty, because expiration time exceeded, or first visit");
		localStorage.removeItem("berenbergCart");
	}
	else {
		var retrievedObject = localStorage.getItem('berenbergCart');
		
		if (retrievedObject == null) {
			console.log("Card is empty, no items yet");
		}
		else {
			console.log("yep, there are items");
			berenbergCart = JSON.parse( retrievedObject );	

			for (let i = 0; i < berenbergCart.items.length; i++) {
				booksInCart += berenbergCart.items[i].amount;
			}
		}	
	}

	setCartIcon();
}

// set the card icon inside nav
export function setCartIcon() {
	if(booksInCart > 0) {
		shopItemsNo.style.display = "flex";
		shopItemsNo.innerHTML = booksInCart;	
	}
	else {
		shopItemsNo.style.display = "none";
	}	
}


// add book to card
function addBook(bookID, bookISBN, bookTitle, bookAuthor, bookPrice) {
	var obj = {id: bookID, amount: 1, isbn: bookISBN, title: bookTitle, author: bookAuthor, price: bookPrice};
	let exists = false;
	
	booksInCart++;
	showNotification.restart();
	showNotification.play();

	for (let i = 0; i < berenbergCart.items.length; i++) {
		
		if(berenbergCart.items[i].id == bookID) {
			exists = true;
			berenbergCart.items[i].amount++;
			console.log("Book allready in Card");
		}
	}

	if(!exists) {
		berenbergCart.items.push(obj);
		console.log("Add Book: ", bookID);
	}
	
	console.log("berenbergCart: ", berenbergCart);
	localStorage.setItem('berenbergCart', JSON.stringify(berenbergCart) );
	setCartIcon();
}